import { Controller } from "react-hook-form";

import { FieldError, Input, Label, TextField } from "@/components/field";
import { useEditRequestFormContext } from "@/features/request/edit/hooks/useEditRequestForm";
import { useFieldUpdate } from "@/features/request/edit/hooks/useFieldUpdate";

export function VideoTechnicalFields() {
  const methods = useEditRequestFormContext();
  const { debouncedUpdateField } = useFieldUpdate();

  return (
    <>
      <Controller
        control={methods.control}
        name="lengthOrPlatform"
        render={({
          field: { name, onBlur, onChange, ref, value },
          fieldState: { error, invalid },
        }) => (
          <TextField
            className="w-full"
            isInvalid={invalid}
            name={name}
            onBlur={onBlur}
            onChange={(e) => {
              onChange(e);
              debouncedUpdateField(name, e);
            }}
            validationBehavior="aria"
            value={value}
          >
            <Label requiredHint>Length or platform</Label>
            <Input placeholder="Indicate length or platform" ref={ref} />
            <FieldError>{error?.message}</FieldError>
          </TextField>
        )}
      />

      <Controller
        control={methods.control}
        name="styleOfVideo"
        render={({
          field: { name, onBlur, onChange, ref, value },
          fieldState: { error, invalid },
        }) => (
          <TextField
            className="w-full"
            isInvalid={invalid}
            name={name}
            onBlur={onBlur}
            onChange={(e) => {
              onChange(e);
              debouncedUpdateField(name, e);
            }}
            validationBehavior="aria"
            value={value}
          >
            <Label>Style of video</Label>
            <Input placeholder="Indicate style of video" ref={ref} />
            <FieldError>{error?.message}</FieldError>
          </TextField>
        )}
      />

      <Controller
        control={methods.control}
        name="musicGenre"
        render={({
          field: { name, onBlur, onChange, ref, value },
          fieldState: { error, invalid },
        }) => (
          <TextField
            className="w-full"
            isInvalid={invalid}
            name={name}
            onBlur={onBlur}
            onChange={(e) => {
              onChange(e);
              debouncedUpdateField(name, e);
            }}
            validationBehavior="aria"
            value={value}
          >
            <Label>Music genre</Label>
            <Input placeholder="Indicate type of music" ref={ref} />
            <FieldError>{error?.message}</FieldError>
          </TextField>
        )}
      />
    </>
  );
}
